


















































































































































































import { Component, Vue, Watch, PropSync, Prop } from 'vue-property-decorator';
import { postSupportMessage } from '@/api/api';
import { SERVICES } from '@/data/services';

@Component({})
export default class Support extends Vue {
    @Prop() active!: boolean;
    msgType: 'help' | 'idea' | 'bug' | 'denounce' | 'other' | 'denounce_assureur' | null = null;
    msgTypeError: string | null = null;
    message: string = '';
    file: { name: string; content: string } | null = null;
    files: File[] = [];
    fileError: string | null = null;
    sending: boolean = false;
    sent: boolean = false;
    helpMessage: boolean = false;
    isDragging: boolean = false;


    previews: string[] = [];
    showPreview = false
    previewSrc: string | null = null

    // Taille maximale des fichiers en octets (25MB)
    maxFileSize: number = 25 * 1024 * 1024;

    // Extensions autorisées
    allowedExtensions: string[] = [
        // Images
        'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp',
        // Documents
        'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx',
        // Texte
        'txt', 'csv'
    ];

    // Types MIME autorisés (pour une sécurité supplémentaire)
    allowedMimeTypes: string[] = [
        // Images
        'image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp',
        // Documents PDF
        'application/pdf',
        // Documents Microsoft Office
        'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        // Texte
        'text/plain', 'text/csv'
    ];

    getService() {
        const service = localStorage.getItem('service');
        if (service) {
            //@ts-ignore
            return SERVICES[service] ? SERVICES[service] : 'PlugIMMO';
        }
        return 'PlugIMMO'
    }

    isImmo() {
        return localStorage.getItem('service') == 'immo'
    }

    isFinance() {
        return localStorage.getItem('service') == 'finance'
    }

    triggerFileInput() {
        (this.$refs.fileInput as HTMLInputElement).click();
    }

    onDragOver(event: DragEvent) {
        this.isDragging = true;
    }

    onDragLeave(event: DragEvent) {
        this.isDragging = false;
    }

    onDrop(event: DragEvent) {
        this.isDragging = false;
        if (event.dataTransfer && event.dataTransfer.files) {
            this.processFiles(event.dataTransfer.files);
        }
    }

    onFileChange(event: Event) {
        const target = event.target as HTMLInputElement;
        if (target && target.files) {
            this.processFiles(target.files);
        }
    }

    // Vérifie si un fichier est autorisé en fonction de son extension
    isFileAllowed(file: File): boolean {
    const fileName = file.name.toLowerCase();
    const fileExtension = fileName.split('.').pop() || '';

    console.log('Vérification fichier autorisé:', {
        name: file.name,
        type: file.type,
        extension: fileExtension,
        extensionAuthorisee: this.allowedExtensions.includes(fileExtension),
        mimeAutorise: this.allowedMimeTypes.includes(file.type)
    });

    // Vérifier l'extension
    if (!this.allowedExtensions.includes(fileExtension)) {
        console.warn(`Extension non autorisée: ${fileExtension}`);
        return false;
    }

    // Vérifier le type MIME avec plus de flexibilité
    const isValidMimeType = this.allowedMimeTypes.some(allowedType =>
        file.type.startsWith(allowedType.split('/')[0])
    );

    if (!isValidMimeType) {
        console.warn(`Type MIME non autorisé: ${file.type}`);
        return false;
    }

    return true;
}

processFiles(fileList: FileList) {
    this.fileError = null;

    Array.from(fileList).forEach(file => {
        console.log('Fichier reçu:', {
            name: file.name,
            type: file.type,
            size: file.size
        });

        if (!this.isFileAllowed(file)) {
            this.fileError = `Le fichier "${file.name}" n'est pas d'un type autorisé.`;
            return;
        }

        if (file.size > this.maxFileSize) {
            this.fileError = `Attention : Le fichier "${file.name}" dépasse la limite autorisée de 25MB.`;
            return;
        }

        if (/[<>:"/\\|?*]/.test(file.name)) {
            this.fileError = `Le nom du fichier "${file.name}" contient des caractères non autorisés.`;
            return;
        }

        this.files.push(file);

        // Générer une prévisualisation si image ou PDF
                if (file.type.startsWith('image/') || file.type === 'application/pdf') {
                const reader = new FileReader();
                reader.onload = (event: ProgressEvent) => {
                    const result = (event.target as FileReader).result;
                    if (typeof result === 'string') {
                    this.previews.push(result);
                    }
                };
                reader.readAsDataURL(file);
                } else {
                this.previews.push('');
                }
            });

            (this.$refs.fileInput as HTMLInputElement).value = '';
}



            openPreview(index: number) {
            const src = this.previews[index];


            this.previewSrc = src;
            this.showPreview = true;
            console.log("index" + index + "    ShowPreview  "+ this.showPreview +  "  previewSrc  "+ this.previewSrc );

            if (!src) return;
            }




        removeFile(index: number) {
            this.files.splice(index, 1);
            this.previews.splice(index, 1);
            this.fileError = null;
        }




    // Déterminer l'icône à utiliser en fonction du type de fichier
    getFileIcon(fileName: string): string {
    let extension = '';
    if (fileName && fileName.includes('.')) {
        extension = fileName.split('.').pop() || '';
    }
    extension = extension.toLowerCase();

    // Mapping plus complet et flexible
    const iconMapping: { [key: string]: string } = {
        // PDF
        'pdf': 'file-pdf',

        // Word documents
        'doc': 'file-word',
        'docx': 'file-word',
        'odt': 'file-word',

        // Excel documents
        'xls': 'file-excel',
        'xlsx': 'file-excel',
        'csv': 'file-excel',
        'ods': 'file-excel',

        // PowerPoint documents
        'ppt': 'file-ppt',
        'pptx': 'file-ppt',
        'odp': 'file-ppt',

        // Image files
        'jpg': 'file-image',
        'jpeg': 'file-image',
        'png': 'file-image',
        'gif': 'file-image',
        'bmp': 'file-image',
        'webp': 'file-image',
        'svg': 'file-image',

        // Text files
        'txt': 'file-text',
        'rtf': 'file-text'
    };

    // Recherche de l'icône, avec une valeur par défaut
    return iconMapping[extension] || 'file';
}

    formatFileSize(size: number): string {
        if (size < 1024) {
            return `${size} B`;
        } else if (size < 1024 * 1024) {
            return `${(size / 1024).toFixed(1)} KB`;
        } else {
            return `${(size / (1024 * 1024)).toFixed(1)} MB`;
        }
    }

    async submit() {
        const service = localStorage.getItem('service')
        this.msgTypeError = null;
        this.fileError = null;

        if (this.msgType === null) {
            this.msgTypeError = 'Vous devez choisir un type de message';
            return;
        }

        if (this.messageError || !service) {
            return;
        }

        if (this.files.some(file => file.size > this.maxFileSize)) {
            this.fileError = "Attention : Un ou plusieurs fichiers dépassent la limite autorisée de 25MB.";
            return;
        }

        this.sending = true;

        try {
            // Convertir les fichiers en base64
            const filesBase64: string[] = await Promise.all(
                this.files.map(async (file) => {
                    return await this.fileToBase64(file);
                })
            );

            // Utiliser la logique qui fonctionne:
            // Stocker les fichiers sous forme de tableau JSON
            if (filesBase64.length > 0) {
                this.file = {
                    name: "multiple_files",
                    content: JSON.stringify(filesBase64)
                };
            } else {
                this.file = null;
            }

            // Préparer les données pour l'envoi
            postSupportMessage({
                //@ts-ignore
                service: SERVICES[service] ? SERVICES[service] : 'PlugIMMO',
                type: this.msgType,
                message: this.message,
                file: this.file ? this.file.content : null,
            })
            .then(data => {
                this.sending = false;
                this.sent = true;
            })
            .catch(error => {
                const $vs = (this as any).$vs;
                $vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    text: "Une erreur est survenue lors de l'envoi du message",
                });
                this.sending = false;
            });
        } catch (error) {
            const $vs = (this as any).$vs;
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: "Une erreur est survenue lors de la préparation des fichiers",
            });
            this.sending = false;
        }
    }

    fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            if (reader.result) {
                // Include the original filename in the base64 data
                const base64String = reader.result.toString();
                const modifiedBase64 = base64String.replace(
                    'data:',
                    `data:;name=${encodeURIComponent(file.name)};`
                );
                resolve(modifiedBase64);
            } else {
                reject(new Error("Échec de la conversion en base64"));
            }
        };
        reader.onerror = error => reject(error);
    });
}

    @Watch('msgType')
    onMsgType(type: string) {
        if (type == 'denounce') {
            this.helpMessage = false;
            this.message = `Nom Promoteur que vous souhaitez prescrire :
Nom programme :
Code postal et ville du Programme :
Nom et prénom prospect déjà dénoncé :
Type bien recherché :
Budget maxi :
Précisez l'usage RP ou Defisc :
On peut appeler le promoteur de votre part oui/non :
Contact chez le promoteur :
Autres commentaires :`;
} else if (type == 'denounce_assureur') {
            this.message = `Nom Assureur que vous souhaitez prescrire :
Nom Support/Produit :
Nom et prénom de votre prospect :
Montant à investir :
Type d'investissement/Placement :
On peut appeler l'assureur de votre part (OUI/NON) :
Contact chez l'assureur :
Autres commentaires :`;
        } else if (type == 'help') {
            this.helpMessage = true;
        } else {
            this.message = '';
            this.helpMessage = false;
        }
    }

    @Watch('active')
    onActiveChanged(val: boolean) {
        if (val) {
            this.sent = false;
            this.msgType = null;
            this.msgTypeError = null;
            this.file = null;
            this.message = '';
            this.files = [];
            this.fileError = null;
        }
    }

    get messageError() {
        if (this.message.length < 30) {
            return '30 caractères minimum';
        }

        if (this.message.length > 5000) {
            return '5000 caractères maximum';
        }

        return null;
    }
}
